export const getBusinessAddonsUrl = () => 'business/addons';

export const getActivateBusinessAddonUrl = (code: string) => `business/addons/${code}/activate`;

export const getCancelBusinessAddonUrl = (code: string) => `business/addons/${code}/cancel`;

export const getReverseBusinessAddonCancellationUrl = (code: string) => `business/addons/${code}/reverse_cancellation`;
